import { faIR } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";
const treeItemClasses = {
  content: "MuiTreeItem-content",
  expanded: "Mui-expanded",
  selected: "Mui-selected",
};

const defaultTheme = createTheme();

const { palette } = defaultTheme;
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const theme = createTheme(
  {
    direction: "rtl",
    palette: {
      type: "light",
      info: createColor("#163ba2"),
      secondary: createColor("#ed001e"),
      primary: createColor("#044F79"),
      warning: createColor("#F6AE2D"),
      navy: createColor("#3C8DBC"),
      success: createColor("#83B692"),
      gray: createColor("#808080"),
      danger: createColor("#FF6A6A"),
      brown: createColor("#251605"),
    },
    typography: {
      fontFamily: "dana FD",
      fontSize: 12,
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          colorSecondary: {
            color: "#555555",
            backgroundColor: "#F1F7FF",
            // minHeight: "6rem",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 20,
            padding: 16,
          },
        },
      },
      MuiCardHeader: {
        styleOverrides: {
          root: {
            padding: 0,
            [defaultTheme.breakpoints.down("sm")]: {
              flexDirection: "column",
              alignItems: "flex-start",
            },
          },
          content: {
            fontWeight: 700,
            fontSize: "1rem",
            color: "#555555",
            borderLeft: "2px solid #3C8DBC",
            paddingLeft: "1rem",
            [defaultTheme.breakpoints.down("sm")]: {
              marginBottom: "1rem",
            },
          },
          title: {
            fontWeight: 700,
            fontSize: "1rem",
            color: "#555555",
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: "1rem 0",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 5,
          },
        },
      },
      // Dialog
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 15,
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            backgroundColor: "#C0D9FF",
            color: "#163BA2",
            textAlign: "center",
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            minHeight: "8rem",
            minWidth: "min(100vw , 24rem)",
            paddingTop: "0.5rem !important",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            minHeight: "3rem",
          },
        },
      },
      MuiTreeItem: {
        styleOverrides: {
          root: {
            color: "#808080",
            [`& .${treeItemClasses.content}`]: {
              borderRadius: 6,
              padding: "0.25rem 0 ",
              marginTop: 1,
              marginBottom: 1,
            },
            [`& .${treeItemClasses.expanded}`]: {
              backgroundColor: "#F1F7FF",
              color: "#163BA2",
            },
            [`& .${treeItemClasses.selected}`]: {
              backgroundColor: "rgba(63, 113, 252, 0.5) !important",
              color: "#163BA2",
              fontWeight: "bold",
            },
          },
        },
      },
    },
  },
  faIR
);

export default theme;
